// extracted by mini-css-extract-plugin
export default {"tableRow":"ExpenseItem_tableRow__+7vUd"};